export default {
    methods: {
        cnzzStat(category, action, label, value, nodeid) {
            if (!category || !action) {
                console.warn('未传入正确的统计参数');
                return false
            }
            console.log(category, action, label)
            if (window._czc) {
                window._czc.push(["_trackEvent", category, action, label, value, nodeid]);
            }
        },
    }
}